<template>
	<div>
		<v-card width="256">
			<v-card-title primary-title> Reservations </v-card-title>
			<v-divider></v-divider>
			<v-navigation-drawer permanent floating>
				<v-list>
					<Link
						as="v-list-item"
						link
						ripple
						:href="
							$route(
								'tenant.reservations.index',
								$page.props.tenant.id
							)
						"
						:input-value="
							$route().current('tenant.reservations.index')
						"
					>
						<v-list-item-content>
							<v-list-item-title>
								{{ $t("label.all") }}
							</v-list-item-title>
						</v-list-item-content>
						<v-list-item-action-text>
							<v-chip color="yellow darken-3" dark>
								{{ item.requested }}
							</v-chip>
						</v-list-item-action-text>
					</Link>
					<v-divider></v-divider>
					<Link
						as="v-list-item"
						link
						ripple
						:href="
							$route(
								'tenant.reservations.pending',
								$page.props.tenant.id
							)
						"
						:input-value="
							$route().current('tenant.reservations.pending')
						"
					>
						<v-list-item-content>
							<v-list-item-title>
								{{ $t("label.pending") }}
							</v-list-item-title>
						</v-list-item-content>
						<v-list-item-action-text>
							<v-chip color="orange accent-4" dark>{{
								item.pending
							}}</v-chip>
						</v-list-item-action-text>
					</Link>
					<v-divider></v-divider>
					<Link
						as="v-list-item"
						link
						ripple
						:href="
							$route(
								'tenant.reservations.confirmed',
								$page.props.tenant.id
							)
						"
						:input-value="
							$route().current('tenant.reservations.confirmed')
						"
					>
						<v-list-item-content>
							<v-list-item-title>
								{{ $t("label.confirmed") }}
							</v-list-item-title>
						</v-list-item-content>
						<v-list-item-action-text>
							<v-chip color="teal darken-3" dark>{{
								item.confirmed
							}}</v-chip>
						</v-list-item-action-text>
					</Link>
					<v-divider></v-divider>
					<Link
						as="v-list-item"
						link
						ripple
						:href="
							$route(
								'tenant.reservations.completed',
								$page.props.tenant.id
							)
						"
						:input-value="
							$route().current('tenant.reservations.completed')
						"
					>
						<v-list-item-content>
							<v-list-item-title>
								{{ $t("label.completed") }}
							</v-list-item-title>
						</v-list-item-content>
						<v-list-item-action-text>
							<v-chip color="green darken-4" dark>{{
								item.completed
							}}</v-chip>
						</v-list-item-action-text>
					</Link>
				</v-list>
			</v-navigation-drawer>
		</v-card>
		<v-card width="256" class="mt-5">
			<v-navigation-drawer permanent floating>
				<v-list>
					<Link
						as="v-list-item"
						link
						ripple
						:href="
							$route(
								'tenant.reservations.no_show',
								$page.props.tenant.id
							)
						"
						:input-value="
							$route().current('tenant.reservations.no_show')
						"
					>
						<v-list-item-content>
							<v-list-item-title>
								{{ $t("label.no_show") }}
							</v-list-item-title>
						</v-list-item-content>
						<v-list-item-action-text>
							<v-chip color="red darken-1" dark>
								{{ item.no_show }}
							</v-chip>
						</v-list-item-action-text>
					</Link>
					<v-divider></v-divider>
					<Link
						as="v-list-item"
						link
						ripple
						:href="
							$route(
								'tenant.reservations.denied',
								$page.props.tenant.id
							)
						"
						:input-value="
							$route().current('tenant.reservations.denied')
						"
					>
						<v-list-item-content>
							<v-list-item-title>
								{{ $t("label.denied") }}
							</v-list-item-title>
						</v-list-item-content>
						<v-list-item-action-text>
							<v-chip color="red darken-1" dark>{{
								item.denied
							}}</v-chip>
						</v-list-item-action-text>
					</Link>
					<v-divider></v-divider>
					<Link
						as="v-list-item"
						link
						ripple
						:href="
							$route(
								'tenant.reservations.canceled',
								$page.props.tenant.id
							)
						"
						:input-value="
							$route().current('tenant.reservations.canceled')
						"
					>
						<v-list-item-content>
							<v-list-item-title>
								{{ $t("label.canceled") }}
							</v-list-item-title>
						</v-list-item-content>
						<v-list-item-action-text>
							<v-chip color="red darken-4" dark>{{
								item.canceled
							}}</v-chip>
						</v-list-item-action-text>
					</Link>
				</v-list>
			</v-navigation-drawer>
		</v-card>
	</div>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue";
export default {
	components: {
		Link,
	},

	computed: {
		item() {
			return {
				requested:
					this.$page.props.reservation_statistic.requested_count,
				pending: this.$page.props.reservation_statistic.pending_count,
				confirmed:
					this.$page.props.reservation_statistic.confirmed_count,
				denied: this.$page.props.reservation_statistic.denied_count,
				completed:
					this.$page.props.reservation_statistic.completed_count,
				canceled: this.$page.props.reservation_statistic.canceled_count,
				no_show: this.$page.props.reservation_statistic.no_show_count,
			};
		},
	},
};
</script>